
// Centraliza el nombre de la app para fácil cambio global
export const APP_NAME = 'Loopaas'
// URL base de la app para links y recursos
export const APP_BASE_URL = process.env.NEXT_PUBLIC_APP_URL || 'https://idsapp.vercel.app'
// Correo de soporte centralizado
export const SUPPORT_EMAIL = 'soporte.idsapp@gmail.com'

// Plan de organización gratuito
export const ORGANIZATION_PLAN_FREE = 'Free'
